module.exports = __webpack_public_path__ + "img/64983cd.png";